import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Toggle from 'material-ui/Toggle';
import toggleStyle from './style';
import './index.css';

const propTypes = {
  onToggle: PropTypes.func.isRequired,
  toggled: PropTypes.bool.isRequired,
  label: PropTypes.element,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  labelPosition: PropTypes.oneOf(['left', 'right']),
};

const defaultProps = {
  disabled: false,
  isLoading: false,
  label: null,
  labelPosition: 'right',
};

const Switch = ({ onToggle, toggled, disabled, isLoading, label, labelPosition }) => {
  return (
    <div
      className={classNames('Switch', {
        is_loading: isLoading,
      })}
    >
      <Toggle
        className="Switch__toggle"
        {...toggleStyle}
        onToggle={onToggle}
        toggled={toggled}
        label={label}
        labelPosition={labelPosition}
        disabled={disabled || isLoading}
      />
    </div>
  );
};

Switch.propTypes = propTypes;
Switch.defaultProps = defaultProps;

export default Switch;



// WEBPACK FOOTER //
// ../ui-components/components/Switch/index.jsx